<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="center">An account of the Military career of Warrant Officer 1 John Sheldon RN.</p>
<p class="centert">This story tells of WO1 John Sheldon’s flying career of over 8,000 hours and 51 years of military service in the Royal Navy, Royal Air Force and the Royal Naval Reserve Air Branch of the Fleet Air Arm.</p>
<p class="centert">Joining the Royal Navy as a fifteen-year-old boy entrant in 1968 not long out of school, then recruited into the Fleet Air Arm as a junior electrician. Later becoming a commando aircrewman and flying in all types of service helicopters and in all of their roles. From first going to the evacuation of Cyprus during the Turkish Invasion in 1974, through Northern Ireland, the Falklands War, the Lebanon, and then on to the first Gulf War, Bosnia, Sierra Leone and then out to Afghanistan. He completed several tours as a Search and Rescue aircrewman, Anti-Submarine Operator and also as an RN/RAF Test aircrewman at the Rotary Wing Test Squadron at Boscombe Down.</p>
<p class="centert">It covers the military action in which John took part, the many incidents and close shaves he was involved in and about the friends he lost during his long and illustrious career.</p>
<p class="centert1">The story of one man’s fifty-one-year career as a Royal Navy and Royal Air Force Helicopter Aircrewman</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Fm.vue?180527bf